import { attr } from 'spraypaint'
import ApplicationRecord from './ApplicationRecord'

const PrintTemplate = ApplicationRecord.extend({
  static: {
    jsonapiType: 'print_templates',
  },
  attrs: {
    id: attr(),
    name: attr(),
  },
})

export default PrintTemplate
